import { ChildBillAdditionalComponent } from 'types';
import { EmptyDisplay } from 'components/molecules';
import styled from 'styled-components';
import { ChildBillAdditionalComponentRow } from './components';

type ChildBillAdditionalComponentListDisplayProps = {
    isPrepaid: boolean;
    childBillAdditionalComponents?: ChildBillAdditionalComponent[];
};

const StyledEmptyDisplay = styled(EmptyDisplay)`
    & {
        margin: 20px auto;

        div {
            margin-top: 0;
        }

        svg {
            height: 80px;
        }
    }
`;

const TableContainer = styled.div`
    width: 100%;
    background: transparent;
`;

export const ChildBillAdditionalComponentListDisplay = ({
    childBillAdditionalComponents,
    isPrepaid,
}: ChildBillAdditionalComponentListDisplayProps) =>
    childBillAdditionalComponents?.length ? (
        <TableContainer>
            {childBillAdditionalComponents?.map((childBillAdditionalComponent, index) => (
                <ChildBillAdditionalComponentRow
                    isPrepaid={isPrepaid}
                    key={childBillAdditionalComponent.id || index}
                    name={childBillAdditionalComponent.name}
                    amountString={childBillAdditionalComponent.amountString}
                    discountString={childBillAdditionalComponent.discountString}
                    vatRate={childBillAdditionalComponent.vatRate}
                    vatAmount={childBillAdditionalComponent.vatAmount}
                    netAmount={childBillAdditionalComponent.netAmount}
                    grossAmount={childBillAdditionalComponent.grossAmount}
                    units={childBillAdditionalComponent.units}
                    unitGrossPrice={childBillAdditionalComponent.unitGrossPrice}
                />
            ))}
        </TableContainer>
    ) : (
        <StyledEmptyDisplay />
    );
